/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { appConfig } from '@/config';
import { useAuth } from '@/hooks/use-auth';
import { useMe } from '@/hooks/use-me';

import { communicationV1EmailsUpdateUpdate } from '../../__generated__/oazapfts-client';
import { GetAllCommunications } from '../queries/get-all-communications';
import { GetOneEmailCommunication } from '../queries/get-one-email-communication';
import { GetOneMeetingCommunication } from '../queries/get-one-meeting-communication';

export namespace UpdateCommunication {
  export type Input = {
    id: string;
    siteIds: string[];
  };

  export type Output = void;

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const auth = useAuth();
    const me = useMe();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const accessToken = await auth.getAccessToken();
        const result = await communicationV1EmailsUpdateUpdate(
          {
            uuid: input.id,
            emailUpdateViewEmailInputRequest: {
              sites_accure_ids: input.siteIds,
            },
            xUserName: me.displayName,
            xUserEmail: me.email,
          },
          {
            baseUrl: `${appConfig.bffUrl}/plex`,
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        if (result.status !== 200) {
          throw new Error('Fail to update meeting minutes');
        }
      },
      async onSuccess(_, input) {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: GetAllCommunications.key({}),
          }),
          queryClient.invalidateQueries({
            queryKey: GetOneEmailCommunication.key({ id: input.id }),
          }),
          queryClient.invalidateQueries({
            queryKey: GetOneMeetingCommunication.key({ id: input.id }),
          }),
        ]);
      },
    });
  }
}
